import React, { useEffect, useRef } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  lifecycle,
  withHandlers,
  withState
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import {
  Button,
  Card,
  CardContent,
  CardMedia,
  Checkbox,
  FormControlLabel,
  Link,
  List,
  ListItem,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  TextField
} from '@material-ui/core';
import {
  AddCircleOutline,
  KeyboardArrowDown,
  KeyboardArrowUp,
  RemoveCircleOutline
} from '@material-ui/icons';
import HelpIcon from '@material-ui/icons/HelpOutlined';
import CloseIcon from '@material-ui/icons/Close';
import classNames from 'classnames';
import moment from 'moment';
import { isNaN } from 'lodash';
import {
  getGochiMenus,
  editGochiMenu,
  addGochiMenuImage,
  EDIT_GOCHI_MENU_SUCCESS
} from '../../actions/GochiMenus';
import { resizeImage, sendLogin, uploadFile } from '../../auth/Auth';
import usageTypes from '../../constants/UsageType';
import RequiredButton from '../../components/atoms/RequiredButton';
import ValidationText from '../../components/atoms/ValidationText';
import FileUpload from '../../components/molecules/FileUpload';
import MenuImageSampleShopDialog from './MenuImageSampleShopDialog';
import { languageType, languages } from '../../constants/Language';
import AnyButton from '../../components/atoms/AnyButton';
import CancelButtonShop from '../../components/atoms/CancelButtonShop';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import GochiMenuEditConfirmShopV2 from './GochiMenuEditConfirmShopV2';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import WarningEditMenuPrice from './WarningEditMenuPrice';

const styles = theme => ({
  root: {
    // position: 'absolute',
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    top: '5%',
    // left: '2%',
    backgroundColor: '#fff',
    padding: 0,
    overflow: 'auto',
    outline: 'none',
    borderRadius: 4,
    paddingBottom: 10,
    color: '#000000'
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff',
    fontSize: 20
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: 0,
    boxShadow: 'none',
    color: '#000000'
  },
  editTable: {
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    },
    '& tr': {
      [theme.breakpoints.down('sm')]: {
        display: 'block'
      }
    }
  },
  textField: {
    padding: '0px',
    width: '100%'
  },
  textFieldLong: {
    padding: '0px',
    width: '100%'
  },
  button: {
    margin: '5px auto'
  },
  priceCalc: {
    color: '#aaa'
  },
  width100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'block',
      padding: 0
    }
  },
  listForm: {
    display: 'block'
  },
  itemForm: {
    display: 'block',
    padding: '20px 20px 12px',
    borderBottom: '1px solid #DDDDDD'
  },
  textExplain: {
    fontSize: 14
  },
  btnBtom: {
    padding: '40px 12px 30px'
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  displayFlex: {
    display: 'flex',
    alignItems: 'end'
    // [theme.breakpoints.down('sm')]: {
    //   display: 'flex',
    //   border: 0,
    //   paddingTop: 0
    // }
  },
  displayFlexPulldown: {
    display: 'flex',
    alignItems: 'flex-end',
    width: '100%'
  },
  displayBlock: {
    display: 'block'
  },
  textYen: {
    width: '30px',
    paddingBottom: 4
  },
  textMutiple: {
    // width: '52px',
    fontWeight: 'bold',
    fontSize: 19,
    paddingLeft: 10,
    paddingRight: 10
  },
  textFieldPriceCombo: {
    padding: '0px 5px 0px 5px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  divisionLabel: {
    fontSize: 12,
    color: 'rgba(0, 0, 0, 0.38)',
    marginTop: 16
  },
  situationPulldown: {
    width: '100%',
    margin: '16px 0px 8px'
  },
  pulldownHeight: {
    maxHeight: '350px'
  },
  usageTypeText: {
    fontSize: 20,
    fontWeight: 700
  },
  divHelp: {
    marginRight: 'auto'
  },
  explainExpirationTitle: {
    fontSize: 10,
    fontWeight: 'bold'
  },
  headerNoteDonation: {
    fontSize: 16,
    fontWeight: 700,
    color: `${theme.palette.primary.main}`
  },
  answerNoteDonation: {
    display: 'flex',
    marginTop: 8
  },
  questionTextDonation: {
    fontSize: 18,
    fontWeight: 400
  },
  answerTextDonation: {
    fontSize: 16,
    fontWeight: 400,
    wordBreak: 'break-all'
  },
  noteLimitTotal: {
    fontSize: 14,
    fontWeight: 400
  },
  iconHelpEx: {
    color: 'gray !important',
    cursor: 'pointer'
  },
  divExplanation: {
    position: 'absolute',
    width: 280,
    top: 53,
    right: 21,
    zIndex: 10
  },
  textHelpExplainDiv: {
    padding: '10px 10px 0 10px'
  },
  textHelpExplain: {
    fontSize: 10
  },
  helpCloseBtn: {
    fontSize: 18,
    position: 'absolute',
    top: 3,
    right: 4,
    cursor: 'pointer'
  },
  helpCloseBtnWhite: {
    color: '#fff !important'
  },
  titleDetail: {
    marginTop: 18,
    fontSize: 24,
    fontWeight: 700
  },
  qaBox: {
    padding: '20px 20px 8px'
  },
  notePriceVoucher: {
    fontSize: 14,
    color: '#F50057',
    marginTop: 8
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name,
      detail: state.gochiMenus.detail,
      shops: state.shops.shops,
      taxTypes: state.gochiMenus.taxTypes,
      reducedTaxMenuPrefix: state.commons.reducedTaxMenuPrefix
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiMenus,
          editGochiMenu,
          addGochiMenuImage
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'setLoading', false),
  withState('message', 'setMessage', ''),
  withState('errorMessage', 'setErrorMessage', ''),
  withState('menuId', 'setMenuId', 0),
  withState('multiLangData', 'setMultiLangData', {}),
  withState('usageType', 'setUsageType', ''),
  withState('menuName', 'setMenuName', ''),
  withState('menuNameError', 'setMenuNameError', ''),
  withState('image', 'setImage', null),
  withState('previewImage', 'setPreviewImage', null),
  withState('isImageDefault', 'setIsImageDefault', false),
  withState('imageError', 'setImageError', ''),
  withState(
    'openMenuImageSamplePopup',
    'updateOpenMenuImageSamplePopup',
    false
  ),
  withState('price', 'setPrice', ''),
  withState('priceError', 'setPriceError', ''),
  withState('priceCalc', 'setPriceCalc', '000 (税込み)'),
  withState('taxType', 'setTaxType', 'INTERNAL'),
  withState('reducedTaxCheck', 'setReducedTaxCheck', false),
  withState('reducedTaxType', 'setReducedTaxType', 'UNREDUCED'),
  withState('menuGenreId', 'setMenuGenreId', null),
  withState('menuGenreName', 'setMenuGenreName', ''),
  withState('menuGenreError', 'setMenuGenreError', ''),
  withState('description', 'setDescription', ''),
  withState('tagStr', 'setTagStr', ''),
  withState('tags', 'setTags', null),
  withState('openAdvancedSetting', 'updateOpenAdvancedSetting', false),
  withState('expirationType', 'setExpirationType', 0),
  withState('expiration', 'setExpiration', ''),
  withState('expirationError', 'setExpirationError', ''),
  withState('expirationEndDate', 'setExpirationEndDate', ''),
  withState('minExpirationDate', 'setMinExpirationDate', () => {
    moment.tz.setDefault('Asia/Tokyo');
    return moment().format('YYYY-MM-DD');
  }),
  withState('maxExpirationDate', 'setMaxExpirationDate', () => {
    moment.tz.setDefault('Asia/Tokyo');
    return moment()
      .add(180, 'days')
      .format('YYYY-MM-DD');
  }),
  withState('expirationList', 'setExpirationList', () => {
    const tmpList = [];
    for (let i = 0; i <= 180; i += 1) {
      tmpList.push({
        label: `${i}日間`,
        value: String(i)
      });
    }
    return tmpList;
  }),
  withState('showQADonation', 'setShowQADonation', false),
  withState('menuLimitTotal', 'setMenuLimitTotal', 0),
  withState('helpExpiration', 'setHelpExpiration', false),
  withState('helpPriceCombo', 'setHelpPriceCombo', false),
  withState('helpQuantityPromotion', 'setHelpQuantityPromotion', false),
  withState('helpPromotionDescription', 'setHelpPromotionDescription', false),
  withState('helpDonation', 'setHelpDonation', false),
  withState('priceCombo', 'setPriceCombo', ''),
  withState('priceComboError', 'setPriceComboError', ''),
  withState('quantityRelease', 'setQuantityRelease', ''),
  withState('quantityReleaseError', 'setQuantityReleaseError', ''),
  withState('quantityPromotion', 'setQuantityPromotion', ''),
  withState('quantityPromotionError', 'setQuantityPromotionError', ''),
  withState('promotionDescription', 'setPromotionDescription', ''),
  withState('usageLimit', 'setUsageLimit', 0),
  withState('quantityReleaseList', 'setQuantityReleaseList', () => {
    const tmpList = [];
    for (let i = 1; i <= 100; i += 1) {
      tmpList.push({
        label: `${i}`,
        value: String(i)
      });
    }
    return tmpList;
  }),
  withState('comboMenu', 'setComboMenu', 0),
  withState('translateType', 'setTranslateType', 0),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('menuChildType', 'setMenuChildType', 1),
  withState('groupId', 'setGroupId', 0),
  withState('groupName', 'setGroupName', ''),
  withState('shopId', 'setShopId', 0),
  withState('shopName', 'setShopName', ''),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('subscriptionInterval', 'setSubscriptionInterval', 'WEEK'),
  withState('subscriptionIntervalCount', 'setSubscriptionIntervalCount', ''),
  withState('subscripIntervalCountError', 'setSubscripIntervalCountError', ''),
  withState('subscription', 'setSubscription', 0),
  withState('menuSituationIds', 'setmenuSituationIds', []),
  withState('menuUserTargetIds', 'setmenuUserTargetIds', []),
  withState('openWarningPrice', 'updateOpenWarningPrice', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    defaultPrice: props => () => {
      let includedTaxPrice = 0;
      let excludedTaxPrice = 0;
      // TODO DBから取得
      let tax = 0.1;
      if (props.editInput.reducedTaxCheck) {
        tax = 0.08;
      }

      if (props.editInput.price !== '') {
        if (props.editInput.taxType === 'INTERNAL') {
          const amountTemp = parseFloat(
            (props.editInput.price / (1 + tax)).toFixed(9)
          );
          const taxAmount = Math.round(amountTemp * tax);
          includedTaxPrice = props.editInput.price;
          excludedTaxPrice = props.editInput.price - taxAmount;
        } else if (props.editInput.taxType === 'DONATION') {
          includedTaxPrice = props.editInput.price;
          excludedTaxPrice = props.editInput.price;
        } else {
          includedTaxPrice =
            props.editInput.price + Math.round(props.editInput.price * tax);
          excludedTaxPrice = props.editInput.price;
        }
      }
      // props.setPriceCalc(`${includedTaxPrice} (税抜 ${excludedTaxPrice})`);
      console.log(excludedTaxPrice);
      const priceShow = includedTaxPrice
        ? parseInt(includedTaxPrice, 0).toString()
        : '0';
      props.setPriceCalc(`${priceShow} (税込み)`);
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.setMenuId(this.props.editInput.menuId);
      this.props.setUsageType(this.props.editInput.usageType);
      this.props.setMenuName(this.props.editInput.menuName);
      this.props.setPreviewImage(this.props.editInput.image);
      this.props.setPrice(this.props.editInput.price);
      this.props.setTaxType(this.props.editInput.taxType);
      this.props.setReducedTaxType(this.props.editInput.reducedTaxType);
      if (this.props.editInput.reducedTaxType === 'REDUCED') {
        this.props.setReducedTaxCheck(true);
      }
      this.props.defaultPrice();
      if (this.props.editInput.menuGenreId) {
        this.props.setMenuGenreId(this.props.editInput.menuGenreId.toString());
      } else {
        this.props.setMenuGenreId(null);
      }
      this.props.setDescription(this.props.editInput.description);
      this.props.setTags(this.props.editInput.tags);
      this.props.setTagStr(this.props.editInput.tagStr);
      this.props.setExpiration(this.props.editInput.expiration);
      if (this.props.editInput.expirationEndDate) {
        this.props.setExpirationType(1);
      } else if (this.props.editInput.expiration) {
        this.props.setExpirationType(0);
      } else {
        this.props.setExpirationType(2);
      }
      this.props.setExpirationEndDate(this.props.editInput.expirationEndDate);
      this.props.setMenuLimitTotal(this.props.editInput.menuLimitTotal || 0);
      this.props.setPriceCombo(this.props.editInput.priceCombo);
      this.props.setQuantityRelease(this.props.editInput.quantityRelease);
      this.props.setQuantityPromotion(this.props.editInput.quantityPromotion);
      this.props.setPromotionDescription(
        this.props.editInput.promotionDescription
      );
      this.props.setUsageLimit(this.props.editInput.usageLimit);
      this.props.setComboMenu(this.props.editInput.comboMenu);
      this.props.setMenuChildType(this.props.editInput.menuChildType);
      this.props.setGroupId(this.props.editInput.groupId);
      this.props.setGroupName(this.props.editInput.groupName);
      this.props.setShopId(this.props.editInput.shopId);
      this.props.setShopName(this.props.editInput.shopName);
      this.props.setUpdatedAt(this.props.editInput.updatedAt);
      this.props.setSubscription(this.props.editInput.subscription);
      this.props.setSubscriptionIntervalCount(
        this.props.editInput.subscriptionIntervalCount
      );
      this.props.setSubscriptionInterval(
        this.props.editInput.subscriptionInterval
      );

      if (
        this.props.editInput.menuSituationIds &&
        this.props.editInput.menuSituationIds.length
      ) {
        this.props.setmenuSituationIds(
          this.props.editInput.menuSituationIds.map(String)
        );
      } else {
        this.props.setmenuSituationIds([]);
      }

      if (
        this.props.editInput.menuUserTargetIds &&
        this.props.editInput.menuUserTargetIds.length
      ) {
        this.props.setmenuUserTargetIds(
          this.props.editInput.menuUserTargetIds.map(String)
        );
      } else {
        this.props.setmenuUserTargetIds([]);
      }

      let dataFirst = {};
      const origilData = {
        menuChildType: null,
        groupId: null,
        shopId: null,
        menuName: null,
        price: null,
        description: null,
        menuCombo: null,
        menuLimitTotal: null,
        priceCombo: null,
        quantity: null,
        quantityFree: null,
        quantityFreeDes: null,
        numberUsePerDay: null,
        expiration: null,
        expirationEndDate: null,
        taxType: null,
        reducedTaxType: null,
        tags: null,
        tagStr: null,
        updatedAt: null,
        groupName: null,
        shopName: null,
        menuGenreId: null,
        menuGenreName: null,
        subscription: null,
        subscriptionIntervalCount: null,
        subscriptionInterval: null,
        menuSituationIds: [],
        menuUserTargetIds: []
      };
      dataFirst = origilData;
      if (this.props.editInput.otherLanguages) {
        const str = JSON.stringify(this.props.editInput.otherLanguages);
        dataFirst.otherLanguages = JSON.parse(str);
      }
      languages.forEach(item => {
        if (item.value === languageType.ORIGIN) return;
        const translatedData = dataFirst.otherLanguages.find(
          el => el.language === item.value
        );
        if (!translatedData) {
          const other = {
            translateType: 0,
            language: item.value
          };
          dataFirst.otherLanguages.push(other);
        }
      });
      this.props.setMultiLangData(dataFirst);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    handleChangePage,
    checkSession,
    updateOpenEdit,
    menuId,
    usageType,
    editInput,
    multiLangData,
    setMultiLangData,
    menuName,
    setMenuName,
    menuNameError,
    setMenuNameError,
    image,
    setImage,
    previewImage,
    setPreviewImage,
    isImageDefault,
    setIsImageDefault,
    openMenuImageSamplePopup,
    updateOpenMenuImageSamplePopup,
    menuImageSampleList,
    price,
    setPrice,
    priceError,
    setPriceError,
    priceCalc,
    setPriceCalc,
    taxType,
    setTaxType,
    taxTypes,
    reducedTaxCheck,
    setReducedTaxCheck,
    reducedTaxType,
    setReducedTaxType,
    menuGenre,
    menuGenreId,
    setMenuGenreId,
    menuGenreName,
    setMenuGenreName,
    menuGenreError,
    setMenuGenreError,
    description,
    setDescription,
    tagStr,
    setTagStr,
    tags,
    setTags,
    openAdvancedSetting,
    updateOpenAdvancedSetting,
    expirationType,
    setExpirationType,
    expiration,
    setExpiration,
    expirationError,
    setExpirationError,
    expirationEndDate,
    setExpirationEndDate,
    minExpirationDate,
    maxExpirationDate,
    expirationList,
    showQADonation,
    setShowQADonation,
    menuLimitTotal,
    helpExpiration,
    setHelpExpiration,
    priceCombo,
    setPriceCombo,
    priceComboError,
    setPriceComboError,
    quantityRelease,
    quantityReleaseList,
    setQuantityRelease,
    quantityReleaseError,
    setQuantityReleaseError,
    quantityPromotion,
    setQuantityPromotion,
    quantityPromotionError,
    setQuantityPromotionError,
    promotionDescription,
    setPromotionDescription,
    comboMenu,
    usageLimit,
    setUsageLimit,
    imageError,
    setImageError,
    translateType,
    isLanguage,
    shopGochiRestriction,
    helpPriceCombo,
    setHelpPriceCombo,
    helpQuantityPromotion,
    setHelpQuantityPromotion,
    helpPromotionDescription,
    setHelpPromotionDescription,
    helpDonation,
    setHelpDonation,
    openEditConfirm,
    updateOpenEditConfirm,
    reducedTaxMenuPrefix,
    message,
    setMessage,
    openProgress,
    updateOpenProgress,
    loading,
    setLoading,
    errorMessage,
    setErrorMessage,
    menuChildType,
    groupId,
    groupName,
    shopId,
    shopName,
    updatedAt,
    subscriptionInterval,
    // setSubscriptionInterval,
    subscriptionIntervalCount,
    // setSubscriptionIntervalCount,
    subscription,
    // setSubscription,
    subscripIntervalCountError,
    setSubscripIntervalCountError,
    menuSituationIds,
    menuUserTargetIds,
    openWarningPrice,
    updateOpenWarningPrice
  }) => {
    const USAGE_TYPE_MENU = usageTypes[0].id;
    const USAGE_TYPE_VOUCHER = usageTypes[1].id;
    const USAGE_TYPE_COMBO = usageTypes[2].id;
    const IMAGE_DEFAULT_VOUCHER = '/images/background_voucher.png';
    const IMAGE_DEFAULT_COMBO = '/images/background_combo.png';

    const errors = {
      menuNameError,
      priceError,
      menuGenreError,
      expirationError,
      priceComboError,
      quantityReleaseError,
      quantityPromotionError,
      imageError,
      subscripIntervalCountError
    };

    const addWaterMark = async inputPrice => {
      const canvas = await new Promise(resolve => {
        let objectURL = '';
        if (usageType === USAGE_TYPE_VOUCHER) {
          objectURL = IMAGE_DEFAULT_VOUCHER;
        } else if (usageType === USAGE_TYPE_COMBO) {
          objectURL = IMAGE_DEFAULT_COMBO;
        }
        const c = document.createElement('canvas');
        const ctx = c.getContext('2d');
        const img = new Image();

        img.onload = () => {
          ctx.canvas.width = img.width;
          ctx.canvas.height = img.height;
          ctx.drawImage(img, 0, 0, img.width, img.height);
          ctx.fillStyle = 'black';
          ctx.font =
            "700 100px 'Yu Gothic','Roboto', 'Helvetica', 'Arial', sans-serif";
          const tempPrice = parseInt(inputPrice, 10);
          const textString = isNaN(tempPrice)
            ? ''
            : `${tempPrice.toLocaleString()}${
                usageType === USAGE_TYPE_VOUCHER ? '円' : '円分'
              }`;
          const textWidth = ctx.measureText(textString).width;
          ctx.fillText(
            textString,
            ctx.canvas.width / 2 - textWidth / 2,
            ctx.canvas.height / 2
          );
          resolve(c);
        };
        img.src = objectURL;
        console.log('objectURL', objectURL);
      });

      return new Promise(resolve => {
        canvas.toBlob(
          newblob => {
            resolve(newblob);
          },
          'image/png',
          1
        );
      });
    };

    const renderImageDefault = async (inputPrice, isClick) => {
      // handle asynchronous when render image from price
      window.priceRenderImageMenu = inputPrice;
      let fileName = '';
      if (!isImageDefault && previewImage && !isClick) {
        return;
      }
      if (usageType === USAGE_TYPE_VOUCHER) {
        fileName = `${editInput.shopName}の${inputPrice}円商品券`;
      } else if (usageType === USAGE_TYPE_COMBO) {
        fileName = `${editInput.shopName}の${inputPrice}円回数券`;
      }
      const newBlob = await addWaterMark(inputPrice);
      const blob = new Blob([newBlob], { type: 'image/png' });
      const newImage = new File([blob], `${fileName}.png`, {
        type: blob.type
      });
      const reader = new FileReader();
      reader.readAsDataURL(newImage);
      setImage(newImage);
      setIsImageDefault(true);
      reader.onloadend = () => {
        if (inputPrice === window.priceRenderImageMenu) {
          setPreviewImage(reader.result);
        }
      };
    };

    const autoRenderDescription = () => {
      if (usageType === USAGE_TYPE_COMBO) {
        if (
          quantityPromotion &&
          quantityPromotion !== '0' &&
          promotionDescription
        ) {
          setDescription(
            `${shopName}のつかえる回数券です。無料で${quantityPromotion}枚が追加されます。${promotionDescription}がつきます。プレゼントにも、ご自身のためにもお使いいただけます。`
          );
        } else if (quantityPromotion && quantityPromotion !== '0') {
          setDescription(
            `${shopName}のつかえる回数券です。無料で${quantityPromotion}枚が追加されます。プレゼントにも、ご自身のためにもお使いいただけます。`
          );
        } else if (promotionDescription) {
          setDescription(
            `${shopName}のつかえる回数券です。${promotionDescription}がつきます。プレゼントにも、ご自身のためにもお使いいただけます。`
          );
        } else {
          setDescription(
            `${shopName}のつかえる回数券です。プレゼントにも、ご自身のためにもお使いいただけます。`
          );
        }
      }
    };

    useEffect(() => {
      autoRenderDescription();
    }, [quantityPromotion, promotionDescription]);

    const cancelAction = () => updateOpenEdit(false);

    const getUsageTypeName = usageTypeId => {
      if (usageTypeId) {
        const usageTypeName = usageTypes.find(
          usage => usage.id.toString() === usageTypeId.toString()
        ).name;
        return usageTypeName;
      }
      return '';
    };

    const handleAddImage = imageInput => {
      setPreviewImage(imageInput);
      setIsImageDefault(false);
      setImageError('');
    };

    const calcPrice = e => {
      let includedTaxPrice = 0;
      let excludedTaxPrice = 0;

      let latestPrice = price;
      if (e.target.id === 'price') {
        latestPrice = e.target.value;
      }

      let latestTaxType = taxType;
      if (e.target.name === 'taxType') {
        latestTaxType = e.target.value;
      }

      if (e.target.id === 'isDonation') {
        if (e.target.checked) {
          latestTaxType = 'DONATION';
        } else {
          latestTaxType = 'INTERNAL';
        }
      }

      let lastestPriceCombo = priceCombo;
      if (e.target.id === 'priceCombo') {
        lastestPriceCombo = e.target.value;
      }

      let lastestQuantityRelease = quantityRelease;
      if (e.target.name === 'quantityRelease') {
        lastestQuantityRelease = e.target.value;
      }

      if (
        lastestPriceCombo &&
        lastestPriceCombo !== '' &&
        lastestQuantityRelease &&
        lastestQuantityRelease !== ''
      ) {
        setPrice(lastestPriceCombo * lastestQuantityRelease);
        renderImageDefault(lastestPriceCombo * lastestQuantityRelease, false);
        latestPrice = lastestPriceCombo * lastestQuantityRelease;
      }
      if (
        (!lastestPriceCombo ||
          lastestPriceCombo === '' ||
          !lastestQuantityRelease ||
          lastestQuantityRelease === '') &&
        comboMenu === 1
      ) {
        setPrice(lastestPriceCombo * lastestQuantityRelease);
        renderImageDefault(lastestPriceCombo * lastestQuantityRelease, false);
        setPriceCalc('000 (税込み)');
        latestPrice = lastestPriceCombo * lastestQuantityRelease;
      }

      // TODO DBから取得
      let tax = 0.1;
      if (
        (e.target.id !== 'reducedTax' && reducedTaxCheck) ||
        (e.target.id === 'reducedTax' && e.target.checked)
      ) {
        // TODO DBから取得
        tax = 0.08;
      }

      if (latestPrice !== '') {
        if (latestTaxType === 'INTERNAL') {
          const amountTemp = parseFloat((latestPrice / (1 + tax)).toFixed(9));
          const taxAmount = Math.round(amountTemp * tax);
          includedTaxPrice = latestPrice;
          excludedTaxPrice = latestPrice - taxAmount;
        } else if (latestTaxType === 'DONATION') {
          includedTaxPrice = latestPrice;
          excludedTaxPrice = latestPrice;
        } else {
          const taxAmount = Math.round(latestPrice * tax);
          includedTaxPrice = latestPrice * 1 + taxAmount;
          excludedTaxPrice = latestPrice;
        }
      }

      // setPriceCalc(`${includedTaxPrice} (税抜 ${excludedTaxPrice})`);
      console.log(excludedTaxPrice);
      const val =
        e.target.id !== 'reducedTax' &&
        typeof e.target.id !== 'undefined' &&
        e.target.id !== 'isDonation'
          ? e.target.value
          : includedTaxPrice;
      console.log('val', val);
      const priceShow =
        val !== '' ? parseInt(includedTaxPrice, 0).toString() : '000';
      setPriceCalc(`${priceShow} (税込み)`);
    };

    const convertReducedTax = checked => {
      if (checked) {
        setReducedTaxType('REDUCED');
      } else {
        setReducedTaxType('UNREDUCED');
      }
    };

    const splitTagStr = str => {
      if (str === '') {
        setTags(null);
      } else {
        setTags(
          str.split(/\s+/).map(t => {
            return { tagName: t };
          })
        );
      }
    };

    const getGenreName = () => {
      if (menuGenreId) {
        const genreName = menuGenre.find(
          genre => genre.menuGenreId.toString() === menuGenreId.toString()
        ).menuGenreName;
        return genreName;
      }
      return '';
    };

    const resetExpirationValue = () => {
      setExpiration('');
      setExpirationEndDate('');
    };

    const ref = useRef();

    const handleClose = e => {
      if (helpPriceCombo) {
        if (ref.current && !ref.current.contains(e.target)) {
          setHelpPriceCombo(false);
        }
      }
      if (helpQuantityPromotion) {
        if (ref.current && !ref.current.contains(e.target)) {
          setHelpQuantityPromotion(false);
        }
      }
      if (helpPromotionDescription) {
        if (ref.current && !ref.current.contains(e.target)) {
          setHelpPromotionDescription(false);
        }
      }
      if (helpExpiration) {
        if (ref.current && !ref.current.contains(e.target)) {
          setHelpExpiration(false);
        }
      }
      if (helpDonation) {
        if (ref.current && !ref.current.contains(e.target)) {
          setHelpDonation(false);
        }
      }
    };

    useEffect(() => {
      document.addEventListener('click', handleClose);
      return () => {
        document.removeEventListener('click', handleClose);
      };
    });

    const handleShowHelpExpiration = () => {
      setHelpExpiration(true);
    };

    const handleShowHelpPriceCombo = () => {
      setHelpPriceCombo(true);
    };

    const handleShowHelpQuantityPromotion = () => {
      setHelpQuantityPromotion(true);
    };

    const handleShowHelpPromotionDescription = () => {
      setHelpPromotionDescription(true);
    };

    const handleShowHelpDonation = () => {
      setHelpDonation(true);
    };

    const handleCloseHelpPopup = () => {
      setHelpPriceCombo(false);
      setHelpQuantityPromotion(false);
      setHelpPromotionDescription(false);
      setHelpExpiration(false);
      setHelpDonation(false);
    };

    const validMenuName = () => {
      const value = menuName;
      if (value.trim() === '') {
        setMenuNameError('必須項目です。');
        return 1;
      }
      setMenuNameError('');
      setMenuName(value);
      return 0;
    };

    const validPrice = () => {
      const value = price;
      if (value === '') {
        setPriceError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPriceError('半角数字のみ入力してください。');
        return 1;
      }
      if (parseInt(value, 10) > 999999999) {
        setPriceError('999,999,999円以下ご入力ください。');
        return 1;
      }
      setPriceError('');
      setPrice(value);
      return 0;
    };

    const validMenuGenre = () => {
      const value = menuGenreId;
      if (!value) {
        setMenuGenreError('必須項目です。');
        return 1;
      }
      setMenuGenreError('');
      setMenuGenreId(value);
      return 0;
    };

    const validPriceCombo = () => {
      const value = priceCombo;
      if (value === '') {
        setPriceComboError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPriceComboError('半角数字のみ入力してください。');
        return 1;
      }
      setPriceComboError('');
      setPriceCombo(parseInt(value, 10));
      return 0;
    };

    const validQuantityRelease = () => {
      const value = quantityRelease;
      if (value === '') {
        setQuantityReleaseError('必須項目です。');
        return 1;
      }
      if (!/^[1-9]|[1-9]\d+$/.test(value)) {
        setQuantityReleaseError('半角数字のみ入力してください。');
        return 1;
      }
      setQuantityReleaseError('');
      setQuantityRelease(parseInt(value, 10));
      return 0;
    };

    const validQuantityPromotion = () => {
      const value = quantityPromotion;
      if (value === '' || !value) {
        setQuantityPromotionError('');
        return 0;
      }
      if (!/^\d+$/.test(value)) {
        setQuantityPromotionError('半角数字のみ入力してください。');
        return 1;
      }
      setQuantityPromotionError('');
      setQuantityPromotion(parseInt(value, 10));
      return 0;
    };

    const validImageMenu = () => {
      const value = previewImage;
      if (!value) {
        setImageError('必須項目です。');
        return 1;
      }
      setImageError('');
      return 0;
    };

    const validExpiration = () => {
      const value = expiration;
      if (!value) {
        setExpirationError('');
        return 0;
      }
      if (!/\b([1-9]|[1-9][0-9]|1[0-7][0-9]|180)\b/.test(value)) {
        setExpirationError('半角数字のみ入力してください。From 1 - 180');
        return 1;
      }
      setExpirationError('');
      setExpiration(parseInt(value, 10));
      return 0;
    };

    const validSubscriptionIntervalCount = () => {
      const checkSubscription = subscription;
      if (checkSubscription === 1) {
        const valueIntervalCount = subscriptionIntervalCount;
        const valueInterval = subscriptionInterval;
        if (valueIntervalCount === '') {
          setSubscripIntervalCountError('必須項目です。');
          return 1;
        }
        if (Number(valueIntervalCount) < 1) {
          setSubscripIntervalCountError('頻度価値は1以上ご入力ください');
          return 1;
        }
        if (!/^\d+$/.test(valueIntervalCount)) {
          setSubscripIntervalCountError('半角数字のみ入力してください。');
          return 1;
        }
        if (valueInterval === 'WEEK' && Number(valueIntervalCount) > 52) {
          setSubscripIntervalCountError(
            '頻度価値は週間サブスクに対して52以下、月間サブスクに対して12以下入力してください。'
          );
          return 1;
        }
        if (valueInterval === 'MONTH' && Number(valueIntervalCount) > 12) {
          setSubscripIntervalCountError(
            '頻度価値は週間サブスクに対して52以下、月間サブスクに対して12以下入力してください。'
          );
          return 1;
        }
      }
      setSubscripIntervalCountError('');
      return 0;
    };

    const valid = () => {
      let errorCount = 0;
      const validMenuNameCount = validMenuName();
      const validImageMenuCount =
        usageType === USAGE_TYPE_MENU ? 0 : validImageMenu();
      if (usageType !== USAGE_TYPE_COMBO) {
        errorCount =
          validMenuNameCount +
          validPrice() +
          validMenuGenre() +
          validImageMenuCount +
          validExpiration() +
          validSubscriptionIntervalCount();
      } else {
        errorCount =
          validMenuNameCount +
          validPriceCombo() +
          validQuantityRelease() +
          validQuantityPromotion() +
          validExpiration() +
          validMenuGenre() +
          validImageMenuCount +
          validSubscriptionIntervalCount();
      }

      if (
        (validMenuNameCount > 0 || validImageMenuCount > 0) &&
        usageType !== USAGE_TYPE_MENU
      ) {
        updateOpenAdvancedSetting(true);
      }

      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const getCurrentData = () => {
      const lang = isLanguage;
      let data = multiLangData;
      const origilParam = {
        menuChildType,
        groupId,
        shopId,
        menuName,
        price,
        description,
        menuCombo: comboMenu,
        menuLimitTotal:
          usageType === USAGE_TYPE_VOUCHER ? menuLimitTotal : undefined,
        priceCombo,
        quantity: quantityRelease,
        quantityFree: quantityPromotion,
        quantityFreeDes: promotionDescription,
        numberUsePerDay: usageLimit,
        expiration,
        expirationEndDate,
        taxType,
        reducedTaxType,
        tags,
        tagStr,
        updatedAt,
        shopName,
        groupName,
        menuGenreId,
        subscription,
        subscriptionIntervalCount:
          subscription === 1 ? subscriptionIntervalCount : undefined,
        subscriptionInterval:
          subscription === 1 ? subscriptionInterval : undefined,
        menuSituationIds,
        menuUserTargetIds,
        usageType
      };
      const otherParam = {
        translateType,
        language: lang,
        params: {
          menuName,
          description,
          quantityFreeDes: promotionDescription
        }
      };
      // origin
      if (lang === languageType.ORIGIN) {
        data = { ...data, ...origilParam };
      } else {
        // other languages
        for (let index = 0; index < data.otherLanguages.length; index += 1) {
          if (data.otherLanguages[index].language === lang) {
            data.otherLanguages[index] = otherParam;
          }
        }
      }
      const str = JSON.stringify(data);
      return JSON.parse(str);
    };

    const confirmAction = () => {
      if (!valid()) {
        alert('登録情報を正しく入力してください。');
      } else {
        setMenuGenreName(getGenreName());
        setMultiLangData(getCurrentData());
        updateOpenEditConfirm(true);
      }
    };

    const backAction = () => {
      updateOpenEditConfirm(false);
    };

    const editAction = async () => {
      setLoading(true);
      updateOpenProgress(true);
      const editedMenu = await actions
        .editGochiMenu(menuId, multiLangData)
        .then(data => checkSession(data));

      if (editedMenu.type === EDIT_GOCHI_MENU_SUCCESS) {
        if (typeof image !== 'undefined' && image !== null) {
          let imageData = image;
          if (imageData.size > Number(process.env.REACT_APP_RESIZE_BORDER)) {
            const { resizeImageFile } = await resizeImage(imageData);
            imageData = resizeImageFile;
          }
          const imagePath = await uploadFile(
            'menu',
            menuId,
            imageData,
            'public'
          );
          await actions
            .addGochiMenuImage(menuId, {
              image: imagePath
            })
            .then(data => checkSession(data));
        }
        setMessage('編集が完了しました。');
      } else {
        setErrorMessage('編集に失敗しました。');
        updateOpenProgress(false);
      }
      setLoading(false);
    };

    const progressOkAction = () => {
      handleChangePage(null, 1, 10);
      updateOpenProgress(false);
      setMessage('');
      updateOpenEditConfirm(false);
      updateOpenEdit(false);
    };

    const handleEditAction = async () => {
      if (
        parseInt(editInput.price, 10) !== parseInt(multiLangData.price, 10) ||
        editInput.reducedTaxType !== multiLangData.reducedTaxType ||
        editInput.taxType !== multiLangData.taxType
      ) {
        updateOpenWarningPrice(true);
      } else {
        await editAction();
      }
    };

    const backWarningPriceAction = () => {
      updateOpenWarningPrice(false);
    };

    return (
      <div className={classes.root}>
        <div className={classes.pageTitle}>
          <Typography className={classes.titleDetail}>メニュー編集</Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <List component="nav" className={classes.listForm}>
            <ListItem style={{ padding: '24px 20px 4px' }}>
              <Typography
                component="div"
                className={classNames(
                  classes.labelControl,
                  classes.usageTypeText
                )}
              >
                {`用途: ${getUsageTypeName(usageType)}`}
              </Typography>
            </ListItem>
            {usageType === USAGE_TYPE_MENU && (
              <>
                <ListItem className={classes.itemForm}>
                  <Typography component="div" className={classes.labelControl}>
                    <RequiredButton />
                  </Typography>
                  <Typography component="div" className={classes.formInput}>
                    <TextField
                      required
                      label="メニュー"
                      defaultValue={editInput.menuName}
                      className={classes.textField}
                      margin="normal"
                      value={menuName}
                      onChange={e => {
                        setMenuName(e.target.value);
                      }}
                      inputProps={{
                        maxLength: 100
                      }}
                      onBlur={validMenuName}
                    />
                    <ValidationText message={errors.menuNameError} />
                  </Typography>
                </ListItem>
                <ListItem className={classes.itemForm}>
                  <Typography component="div" className={classes.labelControl}>
                    <AnyButton />
                  </Typography>
                  <Typography component="div" className={classes.formInput}>
                    <div style={{ marginTop: 16, fontSize: 14 }}>
                      メニュー画像
                    </div>
                    {/* <Button
                      variant="outlined"
                      color="primary"
                      component="span"
                      className={classes.button}
                      onClick={() => updateOpenMenuImageSamplePopup(true)}
                    >
                      デフォルト画像を選択
                    </Button> */}
                    <FileUpload
                      label="image"
                      setFile={setImage}
                      previewImage={previewImage}
                      setPreviewImage={handleAddImage}
                      isOnlyImage
                    />
                    <div className={classes.textExplain}>
                      ※8MB以内でお願いします。
                    </div>
                  </Typography>
                </ListItem>
              </>
            )}
            {usageType === USAGE_TYPE_COMBO ? (
              <ListItem className={classes.itemForm}>
                <Typography component="div" className={classes.labelControl}>
                  <div className={classes.displayFlex}>
                    <div className={classes.divHelp}>
                      <RequiredButton />
                    </div>
                    <HelpIcon
                      className={classes.iconHelpEx}
                      onClick={handleShowHelpPriceCombo}
                    />
                    {helpPriceCombo && (
                      <div ref={ref} className={classes.divExplanation}>
                        <Card>
                          <CardMedia
                            component="img"
                            width="280"
                            className={classes.media}
                            image="images/help_comboPrice.png"
                            title="Menu price explaination"
                          />
                          <CloseIcon
                            className={[
                              classes.helpCloseBtn,
                              classes.helpCloseBtnWhite
                            ]}
                            onClick={handleCloseHelpPopup}
                          />
                          <CardContent className={classes.textHelpExplainDiv}>
                            <Typography
                              variant="body2"
                              component="p"
                              className={classes.textHelpExplain}
                            >
                              メニュー名の後に表示される回数券の「単価」と「発行枚数」です。
                            </Typography>
                          </CardContent>
                        </Card>
                      </div>
                    )}
                  </div>
                </Typography>
                <Typography component="div" className={classes.formInput}>
                  <Typography className={classes.divisionLabel}>
                    単価×発行枚数
                  </Typography>
                  <div className={classes.displayFlex}>
                    <div className={classes.displayFlex}>
                      <TextField
                        id="priceCombo"
                        required
                        label="単価"
                        defaultValue={editInput.priceCombo}
                        className={classes.textFieldPriceCombo}
                        margin="normal"
                        value={priceCombo}
                        onChange={e => {
                          setPriceCombo(e.target.value.trim());
                          calcPrice(e);
                        }}
                        onBlur={validPriceCombo}
                      />
                    </div>
                    <div className={classes.textYen}>円</div>
                    <div className={classes.textMutiple}>×</div>
                    <div className={classes.displayFlexPulldown}>
                      <TextField
                        id="quantityRelease"
                        name="quantityRelease"
                        select
                        required
                        label="発行枚数"
                        defaultValue={editInput.quantityRelease}
                        className={classes.textFieldPriceCombo}
                        InputProps={{
                          shrink: true
                        }}
                        margin="normal"
                        value={quantityRelease}
                        onChange={e => {
                          setQuantityRelease(e.target.value.trim());
                          calcPrice(e);
                        }}
                        onBlur={validQuantityRelease}
                      >
                        {quantityReleaseList.map(item => {
                          return (
                            <MenuItem key={item.value} value={item.value}>
                              {item.label}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </div>
                    <div className={classes.textYen}>枚</div>
                  </div>
                  <div className={classes.displayBlock}>
                    <ValidationText message={errors.priceComboError} />
                    <ValidationText message={errors.quantityReleaseError} />
                  </div>
                </Typography>
              </ListItem>
            ) : (
              <ListItem className={classes.itemForm}>
                <Typography component="div" className={classes.labelControl}>
                  <RequiredButton />
                </Typography>
                <Typography component="div" className={classes.formInput}>
                  <TextField
                    id="price"
                    required
                    disabled={
                      editInput.comboMenu === 1 ||
                      usageType === USAGE_TYPE_VOUCHER
                    }
                    label="価格"
                    defaultValue={editInput.price}
                    className={classes.textField}
                    margin="normal"
                    value={price}
                    onChange={e => {
                      const tempPrice = e.target.value.trim();
                      setPrice(tempPrice);
                      calcPrice(e);
                      if (usageType === USAGE_TYPE_VOUCHER) {
                        const priceText = isNaN(parseInt(tempPrice, 10))
                          ? ''
                          : parseInt(tempPrice, 10).toLocaleString();
                        renderImageDefault(tempPrice, false);
                        setMenuName(`GOCHI ${priceText}円券`);
                        setMenuNameError('');
                        setDescription(
                          `${
                            editInput.shopName
                          }の${priceText}円分使える商品券です。プレゼントにどうぞ。`
                        );
                      }
                    }}
                    onBlur={validPrice}
                  />
                  <ValidationText message={errors.priceError} />
                  <div className={classes.priceCalc}>{priceCalc}</div>
                  {usageType === USAGE_TYPE_VOUCHER && (
                    <div className={classes.notePriceVoucher}>
                      ※商品券の価格変更をご希望される場合は、新規でメニューを追加し、ご希望の価格を設定した代替の商品券メニューを作成してください。
                    </div>
                  )}
                </Typography>
              </ListItem>
            )}
          </List>
          <ListItem className={classes.itemForm}>
            <Typography component="div" className={classes.labelControl}>
              <RequiredButton />
            </Typography>
            <Typography component="div" className={classes.formInput}>
              <div>
                <TextField
                  required
                  id="taxType"
                  name="taxType"
                  select
                  label="税区分"
                  className={classes.textField}
                  margin="normal"
                  value={taxType === 'DONATION' ? 'INTERNAL' : taxType}
                  onChange={e => {
                    setTaxType(e.target.value.trim());
                    calcPrice(e);
                  }}
                  InputLabelProps={{
                    shrink: true
                  }}
                  disabled={
                    taxType === 'DONATION' || usageType !== USAGE_TYPE_MENU
                  }
                >
                  {taxTypes
                    .filter(group => {
                      return group.id !== 'DONATION';
                    })
                    .map(group => {
                      return (
                        <MenuItem key={group.id} value={group.id}>
                          {group.name}
                        </MenuItem>
                      );
                    })}
                </TextField>
              </div>
              {usageType === USAGE_TYPE_MENU && (
                <>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        id="reducedTax"
                        checked={reducedTaxCheck}
                      />
                    }
                    checked={reducedTaxCheck}
                    label="軽減税率対象"
                    onChange={e => {
                      setReducedTaxCheck(e.target.checked);
                      convertReducedTax(e.target.checked);
                      calcPrice(e);
                    }}
                  />
                  <div style={{ fontSize: 14 }}>
                    価格の消費税の設定をお願いします。
                    <br />
                    ・外税
                    <br />
                    ・内税
                    <br />
                    ※テイクアウトの場合は、「軽減税率対象」にチェックを入れてください。
                  </div>
                </>
              )}
            </Typography>
          </ListItem>
          {usageType === USAGE_TYPE_COMBO && (
            <>
              <ListItem className={classes.itemForm}>
                <Typography component="div" className={classes.labelControl}>
                  <div className={classes.displayFlex}>
                    <div className={classes.divHelp}>
                      <AnyButton />
                    </div>
                    <HelpIcon
                      className={classes.iconHelpEx}
                      onClick={handleShowHelpQuantityPromotion}
                    />
                    {helpQuantityPromotion && (
                      <div ref={ref} className={classes.divExplanation}>
                        <Card>
                          <CardMedia
                            component="img"
                            width="280"
                            className={classes.media}
                            image="images/help_quantityPromotion.png"
                            title="Quantity promotion explaination"
                          />
                          <CloseIcon
                            className={[
                              classes.helpCloseBtn,
                              classes.helpCloseBtnWhite
                            ]}
                            onClick={handleCloseHelpPopup}
                          />
                          <CardContent className={classes.textHelpExplainDiv}>
                            <Typography
                              variant="body2"
                              component="p"
                              className={classes.textHelpExplain}
                            >
                              メニュー画像とおまけの下の２箇所に表示される回数券の「付与無料枚数」です。
                            </Typography>
                          </CardContent>
                        </Card>
                      </div>
                    )}
                  </div>
                </Typography>
                <Typography component="div" className={classes.formInput}>
                  <TextField
                    id="quantityPromotion"
                    name="quantityPromotion"
                    select
                    label="付与無料枚数"
                    defaultValue={editInput.quantityPromotion}
                    className={classes.textFieldLong}
                    margin="normal"
                    value={quantityPromotion}
                    InputProps={{
                      shrink: true
                    }}
                    onChange={e => {
                      setQuantityPromotion(e.target.value);
                    }}
                    onBlur={validQuantityPromotion}
                  >
                    {quantityReleaseList.map(item => {
                      return (
                        <MenuItem key={item.value} value={item.value}>
                          {item.label}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                  <ValidationText message={errors.quantityPromotionError} />
                </Typography>
              </ListItem>
              <ListItem className={classes.itemForm}>
                <Typography component="div" className={classes.labelControl}>
                  <div className={classes.displayFlex}>
                    <div className={classes.divHelp}>
                      <AnyButton />
                    </div>
                    <HelpIcon
                      className={classes.iconHelpEx}
                      onClick={handleShowHelpPromotionDescription}
                    />
                    {helpPromotionDescription && (
                      <div ref={ref} className={classes.divExplanation}>
                        <Card>
                          <CardMedia
                            component="img"
                            width="280"
                            className={classes.media}
                            image="images/help_quantityPromotionDescription.png"
                            title="Quantity promotion description explaination"
                          />
                          <CloseIcon
                            className={[
                              classes.helpCloseBtn,
                              classes.helpCloseBtnWhite
                            ]}
                            onClick={handleCloseHelpPopup}
                          />
                          <CardContent className={classes.textHelpExplainDiv}>
                            <Typography
                              variant="body2"
                              component="p"
                              className={classes.textHelpExplain}
                            >
                              メニューの説明文の下に表示される「おまけ」欄です。
                            </Typography>
                          </CardContent>
                        </Card>
                      </div>
                    )}
                  </div>
                </Typography>
                <Typography component="div" className={classes.formInput}>
                  <TextField
                    label="おまけ"
                    defaultValue={editInput.promotionDescription}
                    // multiline
                    // rows="3"
                    className={classes.textFieldLong}
                    margin="normal"
                    value={promotionDescription}
                    inputProps={{
                      maxLength: 1000
                    }}
                    onChange={e => {
                      setPromotionDescription(e.target.value);
                    }}
                  />
                </Typography>
              </ListItem>
            </>
          )}
          <ListItem className={classes.itemForm}>
            <Typography component="div" className={classes.labelControl}>
              <RequiredButton />
            </Typography>
            <Typography component="div" className={classes.formInput}>
              <TextField
                required
                select
                label="ジャンル"
                className={classes.textField}
                margin="normal"
                value={menuGenreId}
                onChange={e => {
                  setMenuGenreId(e.target.value);
                }}
                InputLabelProps={{
                  shrink: true
                }}
                onBlur={validMenuGenre}
              >
                {menuGenre &&
                  menuGenre.map(item => {
                    return (
                      <MenuItem key={item.menuGenreId} value={item.menuGenreId}>
                        {item.menuGenreName}
                      </MenuItem>
                    );
                  })}
              </TextField>
              <ValidationText message={errors.menuGenreError} />
            </Typography>
          </ListItem>
          {usageType === USAGE_TYPE_MENU && (
            <ListItem className={classes.itemForm}>
              <Typography component="div" className={classes.labelControl}>
                <AnyButton />
              </Typography>
              <Typography component="div" className={classes.formInput}>
                <TextField
                  label="説明"
                  multiline
                  rows="4"
                  defaultValue={editInput.description}
                  className={classes.textFieldLong}
                  margin="normal"
                  value={description}
                  inputProps={{
                    maxLength: 1000
                  }}
                  onChange={e => {
                    setDescription(e.target.value);
                  }}
                />
              </Typography>
            </ListItem>
          )}
          <ListItem className={classes.itemForm}>
            <Typography component="div" className={classes.labelControl}>
              <AnyButton />
            </Typography>
            <Typography component="div" className={classes.formInput}>
              <TextField
                label="タグ"
                defaultValue={editInput.tagStr}
                className={classes.textFieldLong}
                margin="normal"
                value={tagStr}
                onChange={e => {
                  setTagStr(e.target.value);
                  splitTagStr(e.target.value);
                }}
              />
            </Typography>
            <Typography component="div" className={classes.textExplain}>
              #おすすめ #おふくろの味 #学生に ＃ガッツリ
              などメニューの特徴を表すタグを記載できます。
            </Typography>
          </ListItem>
          {usageType === USAGE_TYPE_COMBO && (
            <ListItem className={classes.itemForm}>
              <Typography component="div" className={classes.labelControl}>
                <RequiredButton />
              </Typography>
              <Typography component="div" className={classes.formInput}>
                <TextField
                  id="price"
                  required
                  disabled={editInput.comboMenu === 1}
                  label="価格"
                  defaultValue={editInput.price}
                  className={classes.textField}
                  margin="normal"
                  value={price}
                />
                <div className={classes.priceCalc}>{priceCalc}</div>
              </Typography>
            </ListItem>
          )}
          <ListItem>
            <Typography
              component="div"
              className={classes.labelControl}
              style={{ width: '100%' }}
            >
              <div
                className={classes.displayFlex}
                onClick={() => updateOpenAdvancedSetting(!openAdvancedSetting)}
                aria-hidden="true"
                style={{ cursor: 'pointer', alignItems: 'flex-start' }}
              >
                <div
                  style={{
                    fontSize: 20,
                    fontWeight: 700
                  }}
                  className={classes.divHelp}
                >
                  高度な設定
                </div>
                {openAdvancedSetting ? (
                  <KeyboardArrowUp />
                ) : (
                  <KeyboardArrowDown />
                )}
              </div>
              <div style={{ marginTop: 8 }}>
                以下の高度な設定は必須ではありません。詳細設定を希望される場合のみご利用ください。高度な設定により、ご利用条件・ご利用期間などが異なります。項目の詳細を十分にご理解いただいたうえで、設定をお願いいたします。
              </div>
            </Typography>
          </ListItem>
          {openAdvancedSetting && (
            <>
              {usageType !== USAGE_TYPE_MENU && (
                <>
                  <ListItem className={classes.itemForm}>
                    <Typography
                      component="div"
                      className={classes.labelControl}
                    >
                      <RequiredButton />
                    </Typography>
                    <Typography component="div" className={classes.formInput}>
                      <TextField
                        required
                        label="メニュー"
                        defaultValue={editInput.menuName}
                        className={classes.textField}
                        margin="normal"
                        value={menuName}
                        onChange={e => {
                          setMenuName(e.target.value);
                        }}
                        inputProps={{
                          maxLength: 100
                        }}
                        onBlur={validMenuName}
                      />
                      <ValidationText message={errors.menuNameError} />
                    </Typography>
                  </ListItem>
                  <ListItem className={classes.itemForm}>
                    <Typography
                      component="div"
                      className={classes.labelControl}
                    >
                      <RequiredButton />
                    </Typography>
                    <Typography component="div" className={classes.formInput}>
                      <div style={{ marginTop: 16 }}>メニュー画像</div>
                      {!isImageDefault && (
                        <Button
                          variant="outlined"
                          color="primary"
                          component="span"
                          className={classes.button}
                          onClick={() => renderImageDefault(price, true)}
                          disabled={price === ''}
                        >
                          デフォルト画像を選択
                        </Button>
                      )}
                      <FileUpload
                        label="image"
                        setFile={setImage}
                        previewImage={previewImage}
                        setPreviewImage={handleAddImage}
                        isOnlyImage
                      />
                      <ValidationText message={errors.imageError} />
                      <div className={classes.textExplain}>
                        ※8MB以内でお願いします。
                      </div>
                    </Typography>
                  </ListItem>
                  <ListItem className={classes.itemForm}>
                    <Typography
                      component="div"
                      className={classes.labelControl}
                    >
                      <AnyButton />
                    </Typography>
                    <Typography component="div" className={classes.formInput}>
                      <TextField
                        label="説明"
                        multiline
                        rows="4"
                        defaultValue={editInput.description}
                        className={classes.textFieldLong}
                        margin="normal"
                        value={description}
                        inputProps={{
                          maxLength: 1000
                        }}
                        onChange={e => {
                          setDescription(e.target.value);
                        }}
                      />
                    </Typography>
                  </ListItem>
                </>
              )}
              {usageType === USAGE_TYPE_COMBO && (
                <ListItem className={classes.itemForm}>
                  <Typography component="div" className={classes.labelControl}>
                    <AnyButton />
                  </Typography>
                  <Typography component="div" className={classes.divisionLabel}>
                    利用制限
                  </Typography>
                  <RadioGroup
                    row
                    defaultValue={editInput.usageLimit}
                    value={usageLimit}
                    onChange={e => {
                      setUsageLimit(parseInt(e.target.value, 10));
                    }}
                  >
                    <FormControlLabel
                      value={0}
                      control={<Radio color="primary" />}
                      label="なし"
                    />
                    <FormControlLabel
                      value={1}
                      control={<Radio color="primary" />}
                      label="1日1枚"
                    />
                  </RadioGroup>
                </ListItem>
              )}
              <ListItem className={classes.itemForm}>
                <Typography component="div" className={classes.divisionLabel}>
                  <div className={classes.displayFlex}>
                    <div className={classes.divHelp}>
                      <AnyButton />
                    </div>
                    <HelpIcon
                      className={classes.iconHelpEx}
                      onClick={handleShowHelpExpiration}
                    />
                    {helpExpiration && (
                      <div ref={ref} className={classes.divExplanation}>
                        <Card>
                          <CloseIcon
                            className={classes.helpCloseBtn}
                            onClick={handleCloseHelpPopup}
                          />
                          <CardContent className={classes.textHelpExplainDiv}>
                            <Typography className={classes.textHelpExplain}>
                              【指定しない】
                              <br />
                              購入日から180日間ご利用いただけます。
                              <br />
                              <br />
                              【期限指定】
                              <br />
                              利用できる期限日を日付で指定して設定できます。
                              <br />
                              例）〜3月31日まで→購入日に関わらず3月31日まで利用可能
                              <br />
                              <br />
                              【期間指定】
                              <br />
                              チケットを購入してから利用できる期間を日数で指定して設定できます。
                              <br />
                              例）30日間利用可能→購入日が1月1日の場合、1月31日まで利用可能
                              <br />
                              ※チケットの利用期間は最長で購入日から180日間です。
                            </Typography>
                          </CardContent>
                        </Card>
                      </div>
                    )}
                  </div>
                </Typography>
                <Typography component="div" className={classes.divisionLabel}>
                  利用期間
                </Typography>
                <RadioGroup
                  col="true"
                  value={expirationType}
                  onChange={e => {
                    setExpirationType(parseInt(e.target.value, 10));
                    resetExpirationValue();
                  }}
                >
                  <FormControlLabel
                    value={2}
                    control={<Radio color="primary" />}
                    label="指定しない"
                  />
                  <FormControlLabel
                    value={1}
                    control={<Radio color="primary" />}
                    label="期限指定"
                  />
                  <FormControlLabel
                    value={0}
                    control={<Radio color="primary" />}
                    label="期間指定"
                  />
                </RadioGroup>
                {expirationType === 0 && (
                  <Typography component="div" className={classes.formInput}>
                    <TextField
                      select
                      label="利用期間"
                      className={classes.textFieldLong}
                      margin="normal"
                      InputLabelProps={{
                        shrink: true
                      }}
                      defaultValue={editInput.expiration}
                      value={expiration}
                      onChange={e => {
                        setExpiration(e.target.value);
                      }}
                      // onBlur={validExpiration}
                    >
                      {expirationList.map(item => {
                        return (
                          <MenuItem key={item.value} value={item.value}>
                            {item.label}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                    <ValidationText message={errors.expirationError} />
                  </Typography>
                )}
                {expirationType === 1 && (
                  <Typography component="div" className={classes.formInput}>
                    <TextField
                      label="終了"
                      type="date"
                      className={classes.textFieldLong}
                      margin="normal"
                      InputLabelProps={{
                        shrink: true
                      }}
                      defaultValue={editInput.expirationEndDate}
                      value={expirationEndDate}
                      inputProps={{
                        min: minExpirationDate,
                        max: maxExpirationDate
                      }}
                      onChange={e => {
                        setExpirationEndDate(e.target.value);
                      }}
                    />
                  </Typography>
                )}
              </ListItem>
              {usageType === USAGE_TYPE_VOUCHER && (
                <ListItem className={classes.itemForm}>
                  <Typography component="div" className={classes.labelControl}>
                    <RequiredButton />
                  </Typography>
                  <Typography component="div" className={classes.formInput}>
                    <Typography className={classes.divisionLabel}>
                      利用方法
                    </Typography>
                    <RadioGroup value={menuLimitTotal}>
                      <FormControlLabel
                        value={1}
                        disabled
                        control={<Radio color="primary" />}
                        label="一円単位利用"
                      />
                      <div
                        className={classes.noteLimitTotal}
                        style={{ marginBottom: 16 }}
                      >
                        残高が無くなるまで、一円単位で任意の金額を指定してご利用いただけます。
                      </div>
                      <FormControlLabel
                        value={0}
                        disabled
                        control={<Radio color="primary" />}
                        label="一枚単位利用"
                      />
                      <div className={classes.noteLimitTotal}>
                        額面が決まっているチケットを一枚ずつご利用いただけます。お釣りは出ません。
                      </div>
                    </RadioGroup>
                  </Typography>
                </ListItem>
              )}
              {usageType !== USAGE_TYPE_COMBO && (
                <ListItem className={classes.itemForm}>
                  <Typography component="div" className={classes.labelControl}>
                    <div className={classes.displayFlex}>
                      <div className={classes.divHelp}>
                        <AnyButton />
                      </div>
                      <HelpIcon
                        className={classes.iconHelpEx}
                        onClick={handleShowHelpDonation}
                      />
                      {helpDonation && (
                        <div ref={ref} className={classes.divExplanation}>
                          <Card>
                            <CloseIcon
                              className={classes.helpCloseBtn}
                              onClick={handleCloseHelpPopup}
                            />
                            <CardContent className={classes.textHelpExplainDiv}>
                              <Typography
                                className={classes.textHelpExplain}
                                style={{ margin: '20px 0 0' }}
                              >
                                設定すると自動的に「誰でもごち」になり、税率が0％になります。
                                <br />
                                誰でもごちとは？
                                <br />
                                自分用やギフト用に購入するのではなく、「お店に寄付」してお店を訪れた不特定の相手にご利用いただく「ごち（チケット）」です。
                                <br />
                                詳細はマニュアルをご確認ください。
                                <br />
                                {`マニュアル： `}
                                <Link
                                  href="https://shop-guide.gochimeshi.com/individual/daredemogochi-operation-manual/"
                                  target="_blank"
                                  color="primary"
                                >
                                  https://shop-guide.gochimeshi.com/individual/daredemogochi-operation-manual/
                                </Link>
                                <br />
                                ※チケットのご利用には、ユーザー登録が必要です。
                                <br />
                                ※店頭に専用QRコードをご用意いただき、ユーザー様のスマートフォンで読み取っていただく事でチケットを呼び出せます。
                              </Typography>
                            </CardContent>
                          </Card>
                        </div>
                      )}
                    </div>
                  </Typography>
                  <Typography component="div" className={classes.formInput}>
                    <FormControlLabel
                      control={<Checkbox id="isDonation" color="primary" />}
                      label="寄付設定"
                      checked={taxType === 'DONATION'}
                      onChange={e => {
                        if (e.target.checked) {
                          setTaxType('DONATION');
                        } else {
                          setTaxType('INTERNAL');
                        }
                        calcPrice(e);
                      }}
                      disabled={shopGochiRestriction === 'MENTION_ONLY'}
                    />
                  </Typography>
                </ListItem>
              )}
              <ListItem className={classes.qaBox}>
                <Typography
                  component="div"
                  style={{ width: '100%' }}
                  className={classes.labelControl}
                >
                  <div
                    className={classes.displayFlex}
                    style={{ alignItems: 'flex-start', width: '100%' }}
                  >
                    <div className={classes.divHelp}>
                      <span className={classes.headerNoteDonation}>Q.</span>
                      <span className={classes.questionTextDonation}>
                        金額を非表示にするには？
                      </span>
                    </div>
                    {showQADonation ? (
                      <RemoveCircleOutline
                        color="primary"
                        onClick={() => setShowQADonation(false)}
                        style={{ cursor: 'pointer' }}
                      />
                    ) : (
                      <AddCircleOutline
                        color="primary"
                        onClick={() => setShowQADonation(true)}
                        style={{ cursor: 'pointer' }}
                      />
                    )}
                  </div>
                  {showQADonation && (
                    <div className={classes.answerNoteDonation}>
                      <div className={classes.headerNoteDonation}>A.</div>
                      <div className={classes.answerTextDonation}>
                        <div>
                          ギフト券の場合、金額を非表示にすることが可能です。
                          <br />
                          ご要望がある場合はお問い合わせください。
                        </div>
                        <div style={{ marginTop: 8 }}>お問い合わせフォーム</div>
                        <div>
                          <Link
                            href="https://support.gigi.tokyo/contact/contact01/"
                            target="_blank"
                            color="primary"
                          >
                            https://support.gigi.tokyo/contact/contact01/
                          </Link>
                        </div>
                      </div>
                    </div>
                  )}
                </Typography>
              </ListItem>
            </>
          )}
        </Paper>
        <div className={classes.btnBtom}>
          <CancelButtonShop onClickAction={cancelAction} color="primary" />
          <ConfirmButton onClickAction={confirmAction} />
        </div>

        <Modal open={openMenuImageSamplePopup} className={classes.modalMobile}>
          <MenuImageSampleShopDialog
            handleClose={() => updateOpenMenuImageSamplePopup(false)}
            menuImageSampleList={menuImageSampleList}
            setPreviewImage={setPreviewImage}
            setIsImageDefault={setIsImageDefault}
            setImageError={setImageError}
          />
        </Modal>

        <Modal open={openEditConfirm} className={classes.modalMobile}>
          <GochiMenuEditConfirmShopV2
            backAction={backAction}
            editAction={handleEditAction}
            editConfirm={multiLangData}
            reducedTaxMenuPrefix={reducedTaxMenuPrefix}
            previewImage={previewImage}
            menuGenreName={menuGenreName}
            usageTypeName={getUsageTypeName(editInput.usageType)}
          />
        </Modal>

        <WarningEditMenuPrice
          show={openWarningPrice}
          backAction={backWarningPriceAction}
          editAction={editAction}
          isSmall
        />

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={message}
        />

        <ProgressDialog
          openProgress={errorMessage !== ''}
          progressOkAction={() => setErrorMessage('')}
          loading={false}
          resultMessage={errorMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
